import {QueryCommand} from "xmgoing-server";
import GoingUtils from "@/utils/goingUtils";

/**
 * 查询用户根据拼音输入
 * @param value
 * @param backFun
 * @constructor
 */
export function QueryOrgByAccountId(value:string,backFun,showLoading=true){
  showLoading?GoingUtils.showLoading():'';
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/pe-portal/dept/getOrgsByAccountId/`+value,
    method: 'POST'
  });
  queryCommand.executeQuery({
    params: {pinyin: unref(value)}, successFun: (res) => {
      backFun&&backFun(res);
    }
  })
}

/**
 * 查询当前租户的机构信息
 * @param backFun
 * @param showLoading
 * @constructor
 */
export function QueryCurrenOrgs(backFun,showLoading=true){
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/pe-portal/dept/getOrgsByCurAccountId`,
    method: 'POST'
  });
  queryCommand.executeQuery({
    params: {}, successFun: (res) => {
      backFun&&backFun(res);
    }
  })
}
/**
 * 查询机构信息
 * @param value
 * @param backFun
 * @param showLoading
 * @constructor
 */
export function QueryOrgByPinyin(value:string,backFun,showLoading=true){
  showLoading?GoingUtils.showLoading():'';
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/pe-portal/dept/queryOrgByPinyin`,
    method: 'GET'
  });
  queryCommand.executeQuery({
    params: {pinyin: unref(value)}, successFun: (res) => {
      backFun&&backFun(res);
    }
  })
}


/**
 * 查询用户根据拼音输入
 * @param value
 * @param backFun
 * @constructor
 */
export function QueryAllAccountList(value:string,backFun,showLoading=true){
  showLoading?GoingUtils.showLoading():'';
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/pe-portal/account/read_all_casecade`,
    method: 'POST'
  });
  queryCommand.executeQuery({
    params: {pinyin: unref(value)}, successFun: (res) => {
      backFun&&backFun(res);
    }
  })
}
/**
 * 查询用户集合 根据 用户id集合
 * @param params
 * @param backFun
 * @constructor
 */
export function QueryOrgByIds(params:any,backFun){
  if(!params.ids||params.ids==null||params.ids===''){
    return;
  }
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/pe-portal/dept/listByIds`,
    method: 'POST'
  });
  queryCommand.executeQuery({
    params, successFun: (res) => {
      backFun&&backFun(res);
    }
  })
}


/**
 * 查询用户 根据机构id
 * @param params
 * @param backFun
 * @constructor
 */
export function QueryUsersByOrgId(params:any,backFun){
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/pe-portal/users/getUserByOrgId/`+params.orgId,
    method: 'POST'
  });
  queryCommand.executeQuery({
    params, successFun: (res) => {
      backFun&&backFun(res);
    }
  })
}


/**
 * 查询角色列表
 * @param params
 * @param backFun
 * @constructor
 */
export function QueryRoles(params:any,backFun){
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/pe-portal/roles/getAllRoleByBelong/unit`,
    method: 'POST'
  });
  queryCommand.executeQuery({
    params, successFun: (res) => {
      backFun&&backFun(res);
    }
  })
}

/**
 * 查询用户根据角色id
 * @param params
 * @param backFun
 * @constructor
 */
export function QueryUsersByRoleId(params:any,backFun){
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/pe-portal/component/getUserByRoleId/`+params.roleId,
    method: 'POST'
  });
  queryCommand.executeQuery({
    params, successFun: (res) => {
      backFun&&backFun(res);
    }
  })
}

